<!-- 检查计划执行记录 -->
<template>
  <div class="nx-list-page">
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      :beforeOpen="beforeOpen"
      @on-load="onLoad"
      @row-del="rowDel"
    >
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-download"
          :loading="exportLoading"
          @click="handleExport"
        >
          导出
        </el-button>
      </template>
      <template slot-scope="{ row }" slot="timeAndUser">
        <div>{{ row.updateName }}</div>
        <div>{{ row.updateTime }}</div>
      </template>
      <template slot-scope="{ row }" slot="_totalCount">
        <el-progress
          :percentage="getPercentage(row)"
          :format="() => formatProgress(row)"
        />
      </template>
      <template #menu="{ size, row }">
        <el-button
          v-if="row.executionStatus !== 2"
          type="text"
          :size="size"
          icon="el-icon-edit"
          @click="handlePerform('add', row)"
        >
          执行检查
        </el-button>
      </template>
    </avue-crud>
    <dialog-reset
      slotShow
      height="80vh"
      top="2vh"
      width="80%"
      title="新增执行"
      :visible.sync="formVisible"
    >
      <add-form-component
        ref="addFormRef"
        :transmit-data="transmitData"
        @handleClose="handleClose"
      />
    </dialog-reset>
    <dialog-reset
      slotShow
      height="82vh"
      top="2vh"
      width="90%"
      title="执行检查"
      :visible.sync="performVisible"
    >
      <perform-inspection-form
        ref="performInspectionForm"
        :transmit-data="transmitData"
        @handleClose="handleClosePerform"
      />
    </dialog-reset>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, remove, getUserList, getDeptTree, exportExcel } from "./api";
import { downloadXls } from "@/util/util";
import AddFormComponent from "./components/add-form-component.vue";
import PerformInspectionForm from "./components/perform-inspection-form.vue";

export default {
  name: "DispatchCheckPlanListIndex",
  mixins: [crudMixins],
  components: {
    AddFormComponent,
    PerformInspectionForm,
  },
  data () {
    return {
      transmitData: {},
      formVisible: false,
      performVisible: false,
      exportLoading: false,
      apiConfig: { getList, remove },
      option: {
        ...this.$store.state.publicOption,
        // 继承全局：stripe: false、border: false，勿在本页单独开启斑马纹/表格边框
        menuWidth: 200,
        addBtnText: "新增记录",
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "记录编号",
            prop: "recordCode",
            search: true,
            width: 180,
          },
          {
            label: "关联计划名称",
            prop: "planName",
            search: true,
            overHidden: true,
            width: 180,
          },
          {
            label: "检查日期",
            prop: "checkDate",
            overHidden: true,
            search: true,
            type: "date",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
          },
          {
            label: "检查结果",
            prop: "checkResult",
            overHidden: true,
            search: true,
            dicData: this.$store.getters.commonDict["check_result"],
            type: "select",
            dataType: "string",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
          },
          {
            label: "执行状态",
            prop: "executionStatus",
            overHidden: true,
            dicData: this.$store.getters.commonDict["execution_status"],
            type: "select",
            dataType: "string",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
          },
          {
            label: "发现问题数",
            prop: "problemCount",
            overHidden: true,
          },
          {
            label: "解决问题数",
            prop: "solveCount",
            overHidden: true,
          },
          {
            label: "执行进度",
            prop: "_totalCount",
            slot: true,
            overHidden: false,
            className: "cell-check-progress",
            minWidth: 140,
          },
          {
            label: "检查人员",
            prop: "inspectorIds",
            type: "select",
            dicData: [],
            props: {
              label: "name",
              value: "id",
            },
            overHidden: true,
            search: true,
            dataType: "string",
          },
          {
            label: "\u8d23\u4efb\u90e8\u95e8",
            prop: "responsibleDeptId",
            type: "select",
            dicData: [],
            props: {
              label: "deptName",
              value: "id",
            },
            search: true,
            hide: true,
            dataType: "string",
          },
          {
            label: "受检对象",
            prop: "checkAreaName",
            overHidden: true,
            width: 180,
          },
          {
            label: "最新更新人/时间",
            prop: "timeAndUser",
            slot: true,
            overHidden: false,
            minWidth: 160,
          },
        ],
      },
    };
  },
  created () {
    this.init();
  },
  methods: {
    beforeOpen (done, type) {
      this.transmitData = {
        type,
        id: this.form.id || null,
      };
      if (type === "view") {
        this.performVisible = true;
      } else {
        this.formVisible = true;
      }
    },
    getPercentage (row) {
      if (row.checkTotalCount === 0) return 0;
      return Math.round((row.finshTotalCount / row.checkTotalCount) * 100);
    },
    formatProgress (row) {
      return `${row.finshTotalCount}/${row.checkTotalCount}`;
    },
    handlePerform (type, item) {
      this.transmitData = { type, id: item.id || null };
      this.performVisible = true;
    },
    handleClose (type) {
      this.formVisible = false;
      if (type) {
        this.onLoad(this.page, this.query);
      }
    },
    handleClosePerform (type) {
      this.performVisible = false;
      if (type) {
        this.onLoad(this.page, this.query);
      }
    },
    async handleExport () {
      this.exportLoading = true;
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query));
        const res = await exportExcel(params);
        downloadXls(res.data, `检查计划执行记录_${Date.now()}.xlsx`);
        this.$message.success("导出成功");
      } catch (e) {
        console.warn(e);
        this.$message.error((e && e.message) || "导出失败");
      } finally {
        this.exportLoading = false;
      }
    },
    init () {
      getUserList().then(({ data }) => {
        this.findObject(this.option.column, "inspectorIds").dicData = data;
      });
      getDeptTree().then(({ data }) => {
        this.findObject(this.option.column, "responsibleDeptId").dicData = data || [];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep td.cell-check-progress .cell {
  overflow: visible;
}
</style>
